import React from 'react';
import '../legal/UILegalView.css';
import './UIDeleteAccountView.css';
import UIBrand from '../_commons/Brand/UIBrand';
import UIFooter from '../_commons/Footer/UIFooter';

class UIDeleteAccountView extends React.Component {

    constructor(props) {
        super(props);
        this.onBack = this.onBack.bind(this);
    }

    componentDidMount() {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    onBack() {
        const { onUserAction } = this.props;

        if (onUserAction) {
            onUserAction('page', '/');
            return;
        }

        window.history.back();
    }

    render() {

        return (
            <div className="UILegalView UIDeleteAccountView">

                <header className="legal-header">
                    <div className="legal-header-inner">
                        <UIBrand onClick={this.onBack} />
                        <button className="legal-back-btn" onClick={this.onBack}>← Zurück</button>
                    </div>
                </header>

                <section className="legal-content">
                    <div className="legal-content-inner">
                        <h1>Konto löschen</h1>

                        <p>
                            Sie können Ihr Dorffuchs-Konto direkt in der App dauerhaft entfernen.
                        </p>

                        <div className="delete-account-note">
                            Öffnen Sie dazu in der App <strong>Einstellungen -&gt; Konto löschen</strong> und bestätigen Sie den Löschvorgang.
                        </div>

                        <h2>So funktioniert es</h2>
                        <ol className="delete-account-steps">
                            <li>Öffnen Sie die Dorffuchs-App auf Ihrem Smartphone.</li>
                            <li>Wechseln Sie zu <strong>Einstellungen -&gt; Konto löschen</strong>.</li>
                            <li>Bestätigen Sie die Löschung Ihres Kontos.</li>
                        </ol>

                        <p>
                            Nach dem Löschen wird Ihr Konto entfernt. Bereits veröffentlichte Inhalte und zugehörige Kontodaten werden im Rahmen des Löschvorgangs unwiderruflich gelöscht.
                        </p>
                    </div>
                </section>

                <UIFooter />

            </div>
        );
    }
}

export default UIDeleteAccountView;
